import { render, staticRenderFns } from "./PredictiveSearchModal.vue?vue&type=template&id=1b4cb670&scoped=true&lang=pug&"
import script from "./PredictiveSearchModal.vue?vue&type=script&lang=js&"
export * from "./PredictiveSearchModal.vue?vue&type=script&lang=js&"
import style0 from "./PredictiveSearchModal.vue?vue&type=style&index=0&id=1b4cb670&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4cb670",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b4cb670')) {
      api.createRecord('1b4cb670', component.options)
    } else {
      api.reload('1b4cb670', component.options)
    }
    module.hot.accept("./PredictiveSearchModal.vue?vue&type=template&id=1b4cb670&scoped=true&lang=pug&", function () {
      api.rerender('1b4cb670', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/search/PredictiveSearchModal.vue"
export default component.exports